import {FetchState} from "../../common/store/state";
import {Profile} from "../../users/model/profile";

export interface ProfileState {
    currentProfile?: FetchState<Profile>
}

export const ProfileInitialState: ProfileState = {
    currentProfile: {isLoading: false}
}